import { Typography } from '@material-ui/core';
import type { Currency } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import useWizardContext from '@swf/core/hooks/useWizardContext';

import Alert from '../../../../../../../../../components/Alert/Alert';
import {
  isZeroExponentCurrency,
  trimWithoutRounding
} from '../../../../../../../../../utils/cashier';

import {
  TXTWCL_AmountX,
  TXTWCL_EntityX,
  TXTWCL_Expires_onX,
  TXTWCL_If_you_do_not_use_these_detail_ELL,
  TXTWCL_ReferenceX,
  TXTWCL_You_can_complete_your_deposit__ELL_1
} from './MultibancoInfoBox.messages.json';
import { info, infoContainer } from './MultibancoInfoBox.scss';

interface Props {
  depositAmount: number;
  depositCurrency: Currency;
}

const MultibancoInfoBox: React.FC<Props> = ({ depositAmount, depositCurrency }) => {
  const {
    data: { depositResult }
  } = useWizardContext();
  const { expiryTime, entityId, paymentRefId } = depositResult || {};

  return (
    <Alert variant="info">
      <Typography component="div" classes={{ root: info }}>
        <div className={infoContainer}>
          <Translation tagName="p" {...TXTWCL_You_can_complete_your_deposit__ELL_1} />
          <div>
            <Translation tagName="p" {...TXTWCL_EntityX} />
            <span>{entityId}</span>
          </div>
          <div>
            <Translation tagName="p" {...TXTWCL_ReferenceX} />
            <span>{paymentRefId}</span>
          </div>
          <div>
            <Translation tagName="p" {...TXTWCL_Expires_onX} />
            <span>{expiryTime}</span>
          </div>
          <div>
            <Translation tagName="p" {...TXTWCL_AmountX} />
            <span>
              <CurrencyAmount
                value={trimWithoutRounding(depositAmount)}
                isZeroExponentCurrency={isZeroExponentCurrency(depositCurrency)}
                currency={depositCurrency}
                dollarValue
                currencyDisplay="code"
              />
            </span>
          </div>
          <Translation tagName="p" {...TXTWCL_If_you_do_not_use_these_detail_ELL} />
        </div>
      </Typography>
    </Alert>
  );
};
export default MultibancoInfoBox;
